import { render, staticRenderFns } from "./games-fps.vue?vue&type=template&id=7c331b90&scoped=true&"
import script from "./games-fps.vue?vue&type=script&lang=js&"
export * from "./games-fps.vue?vue&type=script&lang=js&"
import style0 from "./games-fps.vue?vue&type=style&index=0&id=7c331b90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c331b90",
  null
  
)

export default component.exports